import RagnaDataTable from '../ReactComponents/RagnaDataTable';
import RagnaLoader from '../ReactComponents/RagnaLoader';
import { ajax_api, wait } from '../../Globals';
import moment from 'moment';
import RagnaModal from '../ReactComponents/RagnaModal';
import { useState } from 'react';
import axios from 'axios';
import Helmet from "react-helmet";

const ActivityLogs = props => {
    const API_URL = `${ajax_api}users/get-logs`;
    const loader = <RagnaLoader />;

    const [modalOpen, setModalOpen] = useState(false);

    const getModalContent = async(d) => {
        var mainContent = <>unknown type..</>;

        //get current user name (if changed)
        var currentUserName = d.CurrentUserName;

        switch(d.Type){
            case "Update":
                var ov = JSON.parse(d.OldValues);
                var nv = JSON.parse(d.NewValues);

                var cols = JSON.parse(d.AffectedColumns);

                var ov_values = [];

                for (var i = 0; i < cols.length; i++) {
                    var key = cols[i];

                    var old_value = ov[key];
                    var new_value = nv[key];

                    //change to date if valid
                    if(moment(ov[key]).isValid()) old_value = moment(old_value).format("MMMM d, YYYY");
                    if(moment(nv[key]).isValid()) new_value = moment(new_value).format("MMMM d, YYYY");

                    switch(key){
                        case "SessionId":
                        case "CouncilId":
                        case "AuthorId":
                            await axios.get(`${ajax_api}users/get-log-names/${key}/${ov[key]}`)
                            .then(r=>old_value = "ID: " + ov[key] + ", Value: " + r.data);
                            await axios.get(`${ajax_api}users/get-log-names/${key}/${nv[key]}`)
                            .then(r=>new_value ="ID: " + nv[key] + ", Value: " + r.data);
                        break;
                    }

                    ov_values.push(<>
                        <tr>
                            <td>
                                {key}
                            </td>
                            <td>
                                { old_value }
                            </td>
                            <td>
                                { new_value }
                            </td>
                        </tr>
                    </>);
                }

                mainContent = <>
                    <table className="table table-sm">
                        <thead>
                            <tr>
                                <th width={150}>Column Name</th>
                                <th>Old Values</th>
                                <th>New Values</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                ov_values
                            }
                        </tbody>
                    </table> 
                </>;
                break;
            case "Added Relation":
            case "Removed Relation":
                //pull data from keys
                var relationKeys = d.Type === "Added Relation" ? JSON.parse(d.NewValues) : JSON.parse(d.OldValues);
                var relationObjectArray = [];
                for(var i = 0; i < relationKeys.length; i++){
                    let _key = relationKeys[i];
                    await axios.get(`${ajax_api}users/get-log-names/${JSON.parse(d.AffectedColumns)[0]}/${_key}`)
                        .then(r=>relationObjectArray.push({Id: _key, Name: r.data}));
                }
                mainContent = 
                <table className="table table-sm">
                    <thead>
                        <tr>
                            <th>ID (Foreign key)</th>
                            <th>Name</th>
                        </tr>
                    </thead>
                    <tbody>
                    {
                        relationObjectArray
                        .map(ro=><tr>
                            <td>{ro.Id}</td>
                            <td>{ro.Name}</td>
                        </tr>)
                    }
                    </tbody>
                </table>;
            break;
            
            case "Create":
                var nv = JSON.parse(d.NewValues);
                var cols = JSON.parse(d.AffectedColumns);

                var ov_values = [];

                for (var i = 0; i < cols.length; i++) {
                    var key = cols[i];

                    var new_value = nv[key];

                    //change to date if valid
                    if(moment(nv[key]).isValid()) new_value = moment(new_value).format("MMMM d, YYYY");

                    switch(key){
                        case "SessionId":
                        case "CouncilId":
                        case "AuthorId":
                        case "ItemType":
                            if(nv[key] != "NULL" && nv[key] != "null"){
                                await axios.get(`${ajax_api}users/get-log-names/${key}/${nv[key]}`)
                                .then(r=>new_value ="ID: " + nv[key] + ", Value: " + r.data);
                            }
                        case "IsApproved":
                            if(nv[key] == ""){
                                new_value = "false";
                            }
                        //ignore date
                        case "Attachment_ItemId":
                        case "Id":
                        case "FtpId":
                        case "DocumentId":
                        case "ScannedId":
                        
                            new_value = nv[key];
                        break;
                    }


                    ov_values.push(<>
                        <tr>
                            <td>
                                {key}
                            </td>
                            <td>
                                { new_value }
                            </td>
                        </tr>
                    </>);
                }

                mainContent = <>
                    <table className="table table-sm">
                        <thead>
                            <tr>
                                <th width={150}>Column Name</th>
                                <th>New Values</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                ov_values
                            }
                        </tbody>
                    </table> 
                </>;
            break;
            
            case "Changed Password":
            case "Reset Password":
                var nv = JSON.parse(d.NewValues);
                var cols = JSON.parse(d.AffectedColumns);

                var ov_values = [];

                for (var i = 0; i < cols.length; i++) {
                    var key = cols[i];

                    var new_value = nv[key];

                    //change to date if valid
                    if(moment(nv[key]).isValid()) new_value = moment(new_value).format("MMMM d, YYYY");

                    switch(key){
                        case "SessionId":
                        case "CouncilId":
                        case "AuthorId":
                        case "ItemType":
                            if(nv[key] != "NULL" && nv[key] != "null"){
                                await axios.get(`${ajax_api}users/get-log-names/${key}/${nv[key]}`)
                                .then(r=>new_value ="ID: " + nv[key] + ", Value: " + r.data);
                            }
                        case "IsApproved":
                            if(nv[key] == ""){
                                new_value = "false";
                            }
                        //ignore date
                        case "Attachment_ItemId":
                        case "Id":
                        case "FtpId":
                        case "DocumentId":
                        case "ScannedId":
                        
                            new_value = nv[key];
                        break;
                    }


                    ov_values.push(<>
                        <tr>
                            <td>
                                {key}
                            </td>
                            <td>
                                { new_value }
                            </td>
                        </tr>
                    </>);
                }

                mainContent = <>
                    <table className="table table-sm">
                        <thead>
                            <tr>
                                <th width={150}>Column Name</th>
                                <th>New Values</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                ov_values
                            }
                        </tbody>
                    </table> 
                </>;
            break;
            case "Report Generated":
                var vals = JSON.parse(d.AffectedColumns);
                var yo =  Object.keys(vals);

                mainContent = <>
                    <table className="table table-sm">
                        <thead>
                            <tr>
                                <th width={250}>Filter Name</th>
                                <th>Filter Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                yo.length == 0 ? <tr>
                                    <td colSpan={2}>No filter used</td>
                                </tr>
                                : yo.map(x=>{
                                    return <tr>
                                        <td>{x=="SP Item Count" ? (yo.length == 1 ? "Total Items Count" : "Filtered Items Count" ) : x}</td>
                                        <td>{vals[x]}</td>
                                    </tr>
                                })
                            }
                        </tbody>
                    </table> 
                </>;
            break;
        }
        var primaryKeyLabel = "ID";
        var primaryKeyJson = JSON.parse(d.PrimaryKey) ?? [];
        
        var primaryKeyValue = "not initialized";

        if(Array.isArray(primaryKeyJson)){
            primaryKeyLabel = primaryKeyJson.map(j=>Object.keys(JSON.parse(j))[0]).join(", ");
            primaryKeyValue = primaryKeyJson.map(j=>JSON.parse(j)[Object.keys(JSON.parse(j))[0]]).join(", ");
        }

        primaryKeyValue = primaryKeyJson["Id"] != null ? primaryKeyJson["Id"] : primaryKeyValue;

        

        if(d.Type === "Added Relation" || d.Type === "Removed Relation"){
        }

        return <>
            <div>
                Timestamp: { moment(d.Timestamp).format("MMMM DD, YYYY hh:mm:ss a")}
            </div>
            <hr />
            <div>
                Table: {d.TableName}
            </div>
            {
                primaryKeyLabel == "" ? "" :
                    <div>
                        {primaryKeyLabel }: {primaryKeyValue}
                    </div>
            }
            <div>
                Action Type: {d.Type}
            </div>
            {
                //get current user name (if changed)
                currentUserName != "" && currentUserName !=  d.UserName ? <>
                <div>
                    User (Old): {d.UserName}
                </div>
                <div>
                    Current User Name: {currentUserName}
                </div>
                </> :  <div>
                    User: {d.UserName}
                </div>
            }
           
            <hr />
            {
                mainContent
            }
        </>
    }

    //datatable options
    const table_columns = [
        { display: "ID", col: "Id" }, 
        { display: "Table", col: "TableName" },
        { display: "Action", col: "Type" },
        { display: "Affected Columns", col: "AffectedColumns", customValue: v=> {
            var vals = JSON.parse(v.AffectedColumns);
            if(vals == null) return "-";
            if(v.Type == "Report Generated"){
                var arr = Object.keys(vals).filter(x=>x!="SP Item Count");
                var yo = arr.length > 3 ? 
                arr.slice(0, 3).join(", ") + " + " + (arr.length - 3 ) + " more" : arr.join(", ");
                return yo == "" ? "(No filter)" : yo;
            }else{
                return vals.length > 3 ? vals.slice(0, 3).join(", ") + " + " + (vals.length - 3 ) + " more" : vals.join(", ");
            }
        } },
        { display: "User", col: "UserName" },
        { display: "Timestamp", col: "Timestamp", customValue: e => moment(e.Timestamp).format("MMMM DD, YYYY hh:mm:ss a") },
        { display: "Action", col: "", customValue: e => <button onClick={_=>{
            setModalContent(loader);
            setModalOpen(true);
            (async()=>{
                var d = await getModalContent(e);
                setModalContent(d)
            })();
        }}>more details</button> },
        //{
        //    display: "Category", col: "ActivityCategory", customValue: e => e.Name ?? "[No Category]", dontOrder: true
        //}
    ];
    const search_columns = [
        { display: "Activity", col: "FullName" }, 
    ];

    const [modalContent, setModalContent] = useState();


    return <>
        <Helmet>
            <title>LTS | Activity Logs</title>
        </Helmet>
        <RagnaModal 
            noBtn={true} 
            modalOpen={modalOpen} 
            setModalOpen={setModalOpen} 
            width={900}
            body={
                modalContent
            }
        />
        <RagnaDataTable
            customEntrySizes={[10, 50, 100, 1000]}
            title="Activity Logs"
            columns={table_columns}
            s_columns={search_columns}
            defaultOrder={false}
            maxPagination={8}
            generalSearch={true}
            defaultOrderCol="Timestamp"
            url={API_URL}
        />
    </>;
}

export default ActivityLogs;